import { preloadPostOfficePlacementWithSessionContext } from '@atlassian/confluence-post-office-provider/entry-points/preload-placement';

import { SSRMeasures } from '@confluence/action-measures/entry-points/SSRMeasures.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';

export const preloadPostOfficeConfluenceSideNav = async (): Promise<void | any[] | Error[]> => {
	const tasks: Promise<any>[] = [];

	const { userId } = getPreloaderFnContext();

	if (userId) {
		const preloadPostOfficeSideNav = async () => {
			return SSRMeasures.run(
				'ssr-app/prepare/preloadQuery/postOffice:ConfluenceSideNav',
				async () => {
					return preloadPostOfficePlacementWithSessionContext('confluence-side-nav');
				},
			);
		};

		tasks.push(preloadPostOfficeSideNav());
	}

	return waitForAllReturnWhenError(tasks);
};
